module.exports = __webpack_public_path__ + "img/616.7f9e5a1b.png";